import { JSEncrypt } from "jsencrypt";
import Cookies from "universal-cookie";

// const static_public_key =
//   "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5ZVnRv7XA/7WsjgqQUmPthlEEgPuotAE8+RTh/AggvdP8G1H926TSe3/NPQubL6Xb9j15j3cMtLHgGRf0xyXaVppTwEVb4ouee2Ldt6CE/TmJReW5BXj703e3+PDxTUQt8wIp7Hj7hDGBEZwxrIg0wlQDQ52bRK7gr+r3HVtW1yV4Kmlt6Kw7AGbD+rrR6eb2r4tWq2X6J1DVnIecd9NpU9/D5Difx+5GRjMbAF3iwpHkFq0H8dEBCIcVxE7R0yG5E2n2GhhGzKYowmWmT2UfyxrVZZ/6bmpINbXSVjMTogDjCUKa1OFor31x7ohCNBP3Ebls8y/vHcoGCQuS5ZBUQIDAQAB";
const publicKey = window.PK;
export function encrypt(message) {
  let RSAEncrypt = new JSEncrypt();
  RSAEncrypt.setPublicKey(publicKey);
  // console.log("### encrypt => message: " + message);
  let encryptedMessage = RSAEncrypt.encrypt(message);
  // console.log("### encrypt => encryptedMessage: " + encryptedMessage);

  return encryptedMessage;
}

export function getParameter(paramName) {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const cookies = new Cookies();
  const cookieName = "accountType";
  const returnUrl="returnUrl";
// console.log("paramName"+  params.get("returnUrl"));
// console.log("account_type>>"+  params.get("account_type"));
if(params.get("account_type")!=null && params.get("account_type")!=""){
	cookies.set("account_type", params.get("account_type"), { path: "/wps/portal/web" });	
}
if(params.get("returnUrl")!=null && params.get("returnUrl")!=""){
	cookies.remove(returnUrl);
	cookies.set(returnUrl, params.get("returnUrl"), { path: "/wps/portal/web" });	
}
if(params.get("profileUpdate")!=null && params.get("returnUrl")!=""){
	cookies.remove(returnUrl);
	cookies.set(returnUrl, params.get("returnUrl"), { path: "/wps/portal/web" });	
}
if (
	    window.location.pathname.includes("login-page") &&
	    params.get("returnUrl") == null && params.get("reg")!="yes" && (params.get("pu")===null ||  params.get("pu")=="null" || params.get("pu")=="") 
	  ) {
	    // console.log("------------> 1 paramName is empty");
	    cookies.remove(returnUrl);
	  }

  if (
    !window.location.pathname.includes("login-page") &&
    params.get(paramName) == ""
  ) {
    // console.log("------------> 1 paramName is empty");
    cookies.remove(cookieName);
  }
  if (
		    window.location.pathname.includes("login-page") &&
		    cookies.get(returnUrl) != null &&
		    params.get(returnUrl) == ""
		  ) {
		    // console.log("------------> 2 cookie: " + cookies.get(cookieName));
		    return cookies.get(returnUrl);
		  }
  if (
    window.location.pathname.includes("login-page") &&
    cookies.get(cookieName) != null &&
    params.get(paramName) == ""
  ) {
    // console.log("------------> 2 cookie: " + cookies.get(cookieName));
    return cookies.get(cookieName);
  }

  // console.log(
  //   "-----> 3 paramName: " + paramName + " - " + params.get(paramName)
  // );
  if (params.get(paramName) != null && params.get(paramName) != "") {
    // console.log("------------> 4 set cookied");
    cookies.remove(cookieName);
    cookies.set(cookieName, params.get(paramName), { path: "/wps/portal/web" });
  }
  return params.get(paramName);
}